import appHelpers from "../appHelpers";


export function amountTypeVisible(){

    var version = appHelpers.getLogoAppVersion() ||"1.0.0";
    const platform = appHelpers.getPlatform();
    var fullVersion = parseInt(version.split(".").join(""))
 
    if (fullVersion>=1006 && platform =="NETSIS") {
        return true;
    }
    if (fullVersion>=1007 && platform !== "NETSIS") {
        return true;
    }
    return false;
}